"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const enum_1 = require("./const/enum");
;
;
const qtyValid = (str) => {
    if (str === '' || str === undefined) {
        return true;
    }
    const num = Number(str);
    if (isNaN(num)) {
        return false;
    }
    return Number.isFinite(num);
};
class RequestHelperImmutable {
    /**
     * Immutable RequestHelper ro assist in constructing the
     * @param {string|object} ccy1  [Optional]  Uppercase currency OR Internal data object
     * @param {string}        ccy2  [Optional]  Uppercase currency
     * @param {string}        ccy   [Optional]  Uppercase currency
     * @param {string}        side  [Optional]  Either SIDE.BUY or SIDE.SELL (lowercase)
     */
    constructor(ccy1OrData, ccy2, ccy, side) {
        console.log('RequestHelperImmutable and RequestHelper are being deprecated in favor of BuySellHelperImmutable');
        if (typeof ccy1OrData === 'object') {
            this.data = ccy1OrData;
        }
        else {
            if (ccy1OrData !== undefined && ccy2 !== undefined) {
                const ccy1 = ccy1OrData;
                const buyingCcy1 = (ccy1 === ccy && side === enum_1.SIDE.BUY);
                const sellingCcy2 = (ccy1 !== ccy && side !== enum_1.SIDE.BUY);
                this.data = {
                    ccy1,
                    ccy2,
                    fixCcy1: (ccy1 === ccy),
                    buyCcy1: buyingCcy1 || sellingCcy2,
                    quantity: ''
                };
            }
            else {
                this.data = {
                    ccy1: '',
                    ccy2: '',
                    fixCcy1: true,
                    buyCcy1: true,
                    quantity: ''
                };
            }
        }
    }
    // Set variables
    setCcy1(ccy1) {
        return this._updateInternal({ ccy1 });
    }
    setCcy2(ccy2) {
        return this._updateInternal({ ccy2 });
    }
    setCcy(ccy1, ccy2) {
        return this._updateInternal({ ccy1, ccy2 });
    }
    swapCcy() {
        return this._updateInternal({
            ccy1: this.data.ccy2,
            ccy2: this.data.ccy1,
            buyCcy1: !this.data.buyCcy1,
            fixCcy1: !this.data.fixCcy1
            // don't need to flip the quantities because fixCcy1 is flipped, which controls the get/set of the quantities
        });
    }
    fixCcy1(quantity) {
        return this._updateInternal({ fixCcy1: true, quantity });
    }
    fixCcy2(quantity) {
        return this._updateInternal({ fixCcy1: false, quantity });
    }
    setRequestedQuantity(quantity) {
        return this._updateInternal({ quantity });
    }
    setQuotedQuantity(quotedQuantity) {
        return this._updateInternal({ quotedQuantity });
    }
    fix(ccy, quantity) {
        if (this.data.ccy1 === ccy) {
            return this.fixCcy1(quantity);
        }
        if (this.data.ccy2 === ccy) {
            return this.fixCcy2(quantity);
        }
        throw new Error('Currency not found');
    }
    buyCcy1() {
        return this._updateInternal({ buyCcy1: true });
    }
    buyCcy2() {
        return this._updateInternal({ buyCcy1: false });
    }
    buy(ccy) {
        if (this.data.ccy1 === ccy) {
            return this.buyCcy1();
        }
        if (this.data.ccy2 === ccy) {
            return this.buyCcy2();
        }
        throw new Error('Currency not found');
    }
    sellCcy1() {
        return this.buyCcy2();
    }
    sellCcy2() {
        return this.buyCcy1();
    }
    sell(ccy) {
        if (this.data.ccy1 === ccy) {
            return this.sellCcy1();
        }
        if (this.data.ccy2 === ccy) {
            return this.sellCcy2();
        }
        throw new Error('Currency not found');
    }
    // Retrieve options
    symbol() {
        return `${this.data.ccy1}/${this.data.ccy2}`;
    }
    currency() {
        return (this.data.fixCcy1 ? this.data.ccy1 : this.data.ccy2);
    }
    side() {
        if (this.data.fixCcy1) {
            return (this.data.buyCcy1 ? enum_1.SIDE.BUY : enum_1.SIDE.SELL);
        }
        return (this.data.buyCcy1 ? enum_1.SIDE.SELL : enum_1.SIDE.BUY);
    }
    rateField() {
        return (this.data.buyCcy1 ? 'client_bid' : 'client_ask');
    }
    quantity() {
        return this.data.quantity;
    }
    ccy1Fixed() {
        return this.data.fixCcy1;
    }
    ccy2Fixed() {
        return !this.data.fixCcy1;
    }
    ccy1QuantityValid() {
        return qtyValid(this.ccy1Quantity());
    }
    ccy2QuantityValid() {
        return qtyValid(this.ccy2Quantity());
    }
    ccy1Quantity() {
        return (this.ccy1Fixed()
            ? this.data.quantity
            : this.data.quotedQuantity);
    }
    ccy2Quantity() {
        return (!this.ccy1Fixed()
            ? this.data.quantity
            : this.data.quotedQuantity);
    }
    ccy1() {
        return this.data.ccy1;
    }
    ccy2() {
        return this.data.ccy2;
    }
    buyCcy() {
        return this.data.buyCcy1 ? this.ccy1() : this.ccy2();
    }
    sellCcy() {
        return this.data.buyCcy1 ? this.ccy2() : this.ccy1();
    }
    // Private Functions
    _updateInternal(data) {
        return new RequestHelperImmutable(Object.assign(this.data, data));
    }
}
exports.RequestHelperImmutable = RequestHelperImmutable;
exports.default = RequestHelperImmutable;
